import { MultiSelectionToolbarItem } from "../types/toolbar-item";
import { RootState } from "../app/store";
import { FEATURE_TABLE_TOOL } from "../constants/map";

export const selectMap = (state: RootState) => state.insight.map

export const selectFeatures = (state: RootState) => state.insight.features

export const selectLayerList = (state: RootState) => state.insight.layer.layerList

export const selectActiveLayer = (state: RootState) => state.insight.layer.activeLayer

export const selectInsightControl = (state: RootState) => state.insight.control

export const selectShowLayerList = (state: RootState) => state.insight.control.showLayerList

export const selectShowToolbar = (state: RootState) => state.insight.control.showToolbar

export const selectShowTilebar = (state: RootState) => state.insight.control.showTileBar

export const selectToolbarItems = (state: RootState) => state.insight.control.toolbarItems

export const selectSelectedFeatureId = (state: RootState) => state.insight.selectedFeatureId

export const selectShowFeatureTable = (state: RootState) => {
    const item = (state.insight.control.toolbarItems.find(x => x.name === FEATURE_TABLE_TOOL) as MultiSelectionToolbarItem)
    return item.isActive
}

export const selectSelectedDrawGeometryTool = (state: RootState) => state.insight.control.selectedDrawGeometryTool

export const selectDrawSource = (state: RootState) => state.insight.drawSource

export const selectDrawGeometry = (state: RootState) => state.insight.drawGeometry

export const selectAttributeQueryParams = (state: RootState) => state.insight.attributeQueryParams

export const selectExtentGeometry = (state: RootState) => state.insight.extentGeometry

export const selectSelectedFilter = (state: RootState) => state.insight.selectedFilter
